import { getViewportSize } from './dom.js';
import { traverseElements } from './traverse.js';

/**
 * Returns elements that have at least one corner visible in the viewport
 * and not occluded by other elements.
 */
export function probeViewport(): Element[] {
    const { width, height } = getViewportSize();
    const points = new PointSet(width, height);
    const result = new Set<Element>();
    for (const el of traverseElements(document.body)) {
        const rect = el.getBoundingClientRect();
        points.add(rect.left, rect.top);
        points.add(rect.right, rect.top);
        points.add(rect.left, rect.bottom);
        points.add(rect.right, rect.bottom);
        points.add(rect.left + rect.width / 2, rect.top + rect.height / 2);
    }
    for (const { x, y } of points.getAll()) {
        const element = document.elementFromPoint(x, y);
        if (element) {
            result.add(element);
        }
    }
    return Array.from(result);
}

export class PointSet {

    private map = new Map<number, Set<number>>();

    constructor(public maxX: number, public maxY: number) {}

    *getAll() {
        for (const [y, set] of this.map.entries()) {
            for (const x of set) {
                yield { x, y };
            }
        }
    }

    has(x: number, y: number): boolean {
        if (x > this.maxX || y > this.maxY) {
            return false;
        }
        const set = this.map.get(y);
        return set ? set.has(x) : false;
    }

    add(x: number, y: number): void {
        if (x > this.maxX || y > this.maxY) {
            return;
        }
        const set = this.map.get(y);
        if (set) {
            set.add(x);
        } else {
            this.map.set(y, new Set([x]));
        }
    }

}
